import { render, staticRenderFns } from "./addCandidatesStoryModal.vue?vue&type=template&id=88743ff8&scoped=true"
import script from "./addCandidatesStoryModal.vue?vue&type=script&lang=js"
export * from "./addCandidatesStoryModal.vue?vue&type=script&lang=js"
import style0 from "./addCandidatesStoryModal.vue?vue&type=style&index=0&id=88743ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88743ff8",
  null
  
)

export default component.exports